import { h } from "preact";
import { useRef, useState } from "preact/hooks";
import { useCommandHandler, useDelay, useDepRef } from "../hooks";
import { Command, CommandHandler } from "../hooks/Command";

export type SnackbarShowCommand = [text: string, type?: string, icon?: string, timeout?: number];

export function Snackbar(props: { action?: string, dismissable?: boolean, doShow: Command<SnackbarShowCommand> }) {
    const [visible, setVisible] = useState(false);
    const [text, setText] = useState("");
    const [type, setType] = useState("");
    const [icon, setIcon] = useState("" as string | undefined);
    const [setHideDelay, clearHideDelay] = useDelay();

    const showHandler = useDepRef<CommandHandler<typeof props.doShow>>([visible])
        .current ||= (text, type, icon, timeout) => {
            if (visible) {
                setVisible(false);
                setHideDelay(300, () => {
                    setText(text);
                    setType(type ?? "");
                    setIcon(icon);
                    setVisible(true);

                    if (timeout) {
                        setHideDelay(timeout, () => setVisible(false));
                    }
                    else {
                        clearHideDelay();
                    }
                });
                return;
            }

            setText(text);
            setType(type ?? "");
            setIcon(icon);
            setVisible(true);

            if (timeout) {
                setHideDelay(timeout, () => setVisible(false));
            }
            else {
                clearHideDelay();
            }
        };

    useCommandHandler(props.doShow, showHandler);

    return <div class={"snackbar " + type + (props.dismissable ? " dismissable" : "") + (visible ? " visible" : "")} data-icon={icon}>
        <span>{text}</span>
        {props.action ? <span class="button flat borderless">{props.action}</span> : null}
        <span class="button icon flat borderless dismiss" onClick={() => {
            setVisible(false);
            clearHideDelay();
        }}>close</span>
    </div>;
}
